export default "__VITE_ASSET__K0e5zMJs__"